export {
	ENDPOINT_PROETHICS_SUMMATIVE,
	ENDPOINT_PROETHICS_TURN,
} from "@constants/urls";

// Mirrors the server-side validation limit on a single turn's text.
export const MAX_TURN_TEXT_LENGTH = 8000;

export const AUDIO_TIMEOUT_MS = 20_000;
